import React from 'react';
import { formatCurrency, formatNumber } from '../../utils/formatters';
import '../../styles/Dashboard.css';

const MetricCard = ({ title, value, icon, trend, type = 'number', color = 'primary' }) => {
  const formatValue = () => {
    if (type === 'currency') {
      return formatCurrency(value);
    }
    return formatNumber(value);
  };

  const getTrendIcon = () => {
    if (!trend) return null;
    if (trend > 0) return '↑';
    if (trend < 0) return '↓';
    return '→';
  };

  const getTrendClass = () => {
    if (!trend) return '';
    if (trend > 0) return 'trend-up';
    if (trend < 0) return 'trend-down';
    return 'trend-neutral';
  };

  return (
    <div className={`metric-card metric-card-${color}`}>
      <div className="metric-header">
        <span className="metric-icon">{icon}</span>
        <h3 className="metric-title">{title}</h3>
      </div>
      <div className="metric-body">
        <div className="metric-value">{formatValue()}</div>
        {trend !== undefined && (
          <div className={`metric-trend ${getTrendClass()}`}>
            <span className="trend-icon">{getTrendIcon()}</span>
            <span className="trend-value">{Math.abs(trend)}%</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default MetricCard;

// Made with Bob
